import { useState } from "react";
import { Link } from "react-router-dom";
import { Box, IconButton, Typography, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as RightARROW } from "assets/images/arrow.svg";


const CallToActionBlock = () => {
  const [open, setOpen] = useState(true);
  if(!open) return false;
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        p: 3,
        mb: 3,
        borderRadius: 3,
        background: 'linear-gradient(109.6deg, rgb(0, 182, 255) 11.2%, rgb(102, 51, 153) 91.1%)', // Updated background color
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
        color: 'white',
        textAlign: 'center',
        width : 350
      }}
    >
      <IconButton
        aria-label="close"
        onClick={() => setOpen(false)}
        sx={{
          position: 'absolute',
          top: 7,
          right: 7,
          color: 'white',
        }}
      >
        <CloseIcon sx={{color:"white !important"}} />
      </IconButton>
      
      <Typography sx={{color:"white !important"}} variant="h6" component="div" gutterBottom>
        Devenez l'un de nos distributeurs !
      </Typography>
      <Typography sx={{color:"white !important"}} variant="body2" gutterBottom>
        Rejoignez notre réseau et profitez d'avantages exclusifs, d'une visibilité accrue et d'une
        collaboration gagnante. Contactez-nous dès aujourd'hui !
      </Typography>
      
      <Button
        variant="contained"
        fullWidth 
        component={Link}
        to={"/distributors"}
        sx={{
          mt:2,
          background: 'radial-gradient(circle at 84.6% 77.8%, rgb(86, 89, 218) 0%, rgb(95, 208, 248) 90%)', // Button gradient background
          borderRadius: 3,
          color: 'white !important',
          padding: '10px 20px',
          position: 'relative',
          overflow: 'hidden',
          zIndex: 1,
          boxShadow: '0 0 10px #00acee, 0 0 20px #8a2be2',
          "& .right-arrow" :{
            margin:"0 10px"
           },
          '&:hover': {
            boxShadow: '0 0 20px #00acee, 0 0 40px #8a2be2',
            background: 'linear-gradient(45deg, #3b5998, #007bff)',
            "& .right-arrow" :{
                marginLeft:"20px"
            }
          },
          '&:focus': {
            outline: 'none',
            boxShadow: '0 0 20px #00acee, 0 0 40px #8a2be2',
          },
        }}
        onClick={() => { /* Handle click action */ }}
      >
        Je veux en savoir plus <RightARROW className="right-arrow" style={{ transition : '.6s'}} />
      </Button>
    </Box>
  );
};

export default CallToActionBlock;
